import { useNavigate } from "@tanstack/react-location";
import { MouseEventHandler, useCallback } from "react";

export const useSPALink = () => {
  const navigate = useNavigate();
  const handler: MouseEventHandler<HTMLAnchorElement> = useCallback(
    (e) => {
      e.preventDefault();
      navigate({ to: e.currentTarget.getAttribute("href") });
    },
    [navigate]
  );

  return handler;
};
